<template>
  <ankh-list :show-search-form="false">
    <template #btn-group>
      <el-button @click.native="showDialog = true">{{$t('新增')}}</el-button>
      <el-button @click.native="handleBatchDelete">{{$t('批量删除')}}</el-button>
    </template>

    <template #table="{height}">

      <table-list
          ref="list"
          :height="height"
          @query="handleSearch"
          :search-params="searchForm"
          :data="tableData"
          @selection-change="selection = $event">

        <el-table-column align="center" type="selection" width="50"/>

        <el-table-column align="center" prop="name" :label="$t('使用地区')" fixed/>
        <el-table-column align="center" prop="areaDataName" :label="$t('地区服务器')" fixed/>
        <el-table-column align="center" prop="releaseTime" :label="$t('更改时间')">
          <template v-slot="{row}">
            {{row.updateTime | formatDate}}
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('app显示')" prop="appShow">
          <template v-slot="{row}">
            <el-switch inactive-value="no" active-value="yes" v-model="row.appShow" @change="handleChangeStatus($event, row)" />
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('默认展示')" prop="appShow">
          <template v-slot="{row}">
            <el-switch inactive-value="no" active-value="yes" v-model="row.isDefault" @change="handleChangeDefault($event, row)" />
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="$t('操作')" align="center">
          <template v-slot="{row}">
            <div class="fb-gap-10 flex-center">
              <el-link :underline="false" type="primary" @click="handleEdit(row)">{{$t('更改绑定')}}</el-link>
              <el-link :underline="false" type="danger" @click="handleDelete(row)">{{$t('删除')}}</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>

    <template #other>
      <el-dialog :visible.sync="showDialog" :title="formData.code ? $t('编辑') : $t('新增')" :close-on-click-modal="false" @close="handleCloseFormDialog" width="500px">
        <el-form :model="formData" ref="form" :rules="formRule" inline>
          <el-form-item :label="$t('使用地区')" prop="name">
            <el-input  :placeholder="$t('请输入使用地区')" v-model="formData.name" />
          </el-form-item>
          <el-form-item :label="$t('地区服务器')" prop="areaDataCode">
            <el-select v-model="formData.areaDataCode" :placeholder="$t('请选择地区服务器')">
              <el-option v-for="item in areaDataList" :key="item.code" :value="item.code" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button type="primary" @click="handleSave">{{$t('保存')}}</el-button>
          <el-button @click="showDialog = false">{{$t('取消')}}</el-button>
        </template>
      </el-dialog>
    </template>

  </ankh-list>
</template>

<script>
import {request, requestByTip} from "@/config/request";
import TableList from "@/components/table-list/TableList";
import AnkhList from "@/components/list/AnkhList.vue";
export default {
  name: "UseAreaList",
  components: {AnkhList, TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
      showDialog: false,
      formData: {
        code: null,
        name: "",
        areaDataCode: ""
      },
      formRule: {
        name: {required: true, message: this.$t('请输入使用地区'), trigger: "blur"},
        areaDataCode: {required: true, message: this.$t('请旋转地区服务器'), trigger: "change"}
      },
      areaDataList: []
    }
  },
  methods: {
    // 切换默认显示
    async handleChangeDefault(e, row) {
      try {
        const params = {
          code: row.code,
          isDefault: e
        }
        await request(this.$api.useArea.updateDefault, params);
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();
      } catch (err) {
        console.error(err);
      }
    },

    async handleChangeStatus(e, row) {
      try {
        const params = {
          code: row.code,
          appShow: e
        }
        await request(this.$api.useArea.updateStatus, params);
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();
      } catch (err) {
        console.error(err);
      }
    },

    handleSave() {
      this.$refs.form.validate( async valid => {
        if(!valid) return;
        const action = this.formData.code ? this.$api.useArea.update : this.$api.useArea.add;
        await request(action, this.formData);
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();
        this.showDialog = false;
      })
    },

    // 关闭弹窗
    handleCloseFormDialog() {
      this.formData = {code: null};
    },

    handleEdit(row) {
      this.formData = {...row};
      delete this.formData.createTime;
      delete this.formData.updateTime;
      this.showDialog = true;
    },

    async handleDelete(row) {
      try {
        await requestByTip(this.$api.useArea.delete, {code: row.code});
        this.$message.success(this.$t('操作成功'))
        this.$refs.list.handleRequest(1);
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      try {
        let codes = this.selection.map(item => item.code);
        if(!codes.length) {
          this.$message.warning(this.$t('请选择要删除的项'));
          return;
        }
        await requestByTip(
            this.$api.useArea.batchDelete,
            codes,
            {isJson: true},
            {message: this.t('您现在正在进行批量删除操$作, 是否继续?')}
        );
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest(codes.length);
      } catch (e) {
        console.error(e);
      }
    },

    async handleSearch(params, setTotal) {
      try {
        let res = await request(this.$api.useArea.list, params);
        for (let key in res) {
          if (res[key] instanceof Array) {
            this.tableData = res[key];
          }
        }
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    },

    async loadAreaList() {
      try {
        let res = await request(this.$api.areaData.list, {onPage: false});
        this.areaDataList = res.areaDatas;
      } catch (e) {
        console.error(e);
      }
    }

  },
  created() {
    this.loadAreaList();
  }
}
</script>

<style scoped>

</style>
